import Module from '../../Module';
import { City } from '../';
import services from 'core/services';

class Province extends Module {
  get baseURL() {
    return '/api/v1/provinces'
  }

  parseProvinces(provinces) {
    return provinces.map(province => {
      return this.parseProvince(province)
    })
  }

  parseProvince(province) {
    return {
      createdAt: province.createdAt,
      deletedAt: province.deletedAt,
      id: province.id,
      name: province.name,
      updatedAt: province.updatedAt,
      cities: province.cities ? City.parseCities(province.cities) : []
    }
  }

  getProvinces(params) {
    return new Promise( ( resolve, reject ) => {
      this.handler
        .get(`${this.baseURL}`, {
          params: params
        })
          .then(r => {
            resolve(
              this.parseResponse(r, data => ({
                provinces: this.parseProvinces(data.provinces)
              }))
            )
          })
          .catch(e => {
            reject(this.parseResponse(e))
          })
    })
  }
}

export default new Province()